var _excluded = ["header", "children", "borderRadius", "tabIndex", "onKeyDown"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { styled as t, css as i } from "styled-components";
import { jsxs as n, jsx as a } from "react/jsx-runtime";
import { forwardRef as w } from "react";
var m = t.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column;\n  background: ", ";\n"])), function (_ref) {
    var e = _ref.theme;
    return e.colors.black100;
  }),
  $ = t.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  min-height: 16px;\n  font-size: 13px;\n"])));
t.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
t.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 1;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  white-space: nowrap;\n  margin: 0;\n"])));
t.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
t($)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n  margin-top: 8px;\n  min-height: 1em;\n  font-size: 16px;\n"])));
t.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
t.p(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  line-height: 1;\n  letter-spacing: 0.1px;\n  color: ", ";\n"])), function (_ref2) {
  var e = _ref2.theme;
  return e.colors.red50;
});
i(["font-family:inherit;font-weight:400;font-size:16px;line-height:22px;", "{font-size:14px;}"], function (_ref3) {
  var e = _ref3.theme.down;
  return e("tablet");
});
var s = "0px 1px 8px rgba(0, 0, 0, 0.17)",
  p = "0px 4px 20px rgba(0, 0, 0, 0.07)",
  d = "0px 4px 28px rgba(0, 0, 0, 0.14)";
i(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], s);
var u = i(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], p);
i(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], d);
i(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], s);
i(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], p);
i(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], d);
var x = t.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref4) {
    var e = _ref4.theme,
      o = _ref4.$plain;
    return o && i(["background:", ";padding:12px 24px;"], e.colors.black95);
  }),
  k = t(m)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  ", "\n\n  & ", " {\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n  }\n\n  &:focus {\n    outline: none;\n  }\n"])), function (_ref5) {
    var e = _ref5.$borderRadius;
    return "".concat(e, "px");
  }, u, x, function (_ref6) {
    var e = _ref6.$borderRadius;
    return "".concat(e, "px");
  }, function (_ref7) {
    var e = _ref7.$borderRadius;
    return "".concat(e, "px");
  }),
  y = t.h3(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 18px;\n  line-height: 24px;\n"])), function (_ref8) {
    var e = _ref8.theme;
    return e.colors.black50;
  }),
  v = t.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  padding: ", ";\n"])), function (_ref9) {
    var e = _ref9.$minimizeHeaderPadding;
    return e ? "8px 24px 32px;" : "32px 24px";
  }),
  z = /*#__PURE__*/w(function (_ref10, g) {
    var e = _ref10.header,
      o = _ref10.children,
      _ref10$borderRadius = _ref10.borderRadius,
      f = _ref10$borderRadius === void 0 ? 8 : _ref10$borderRadius,
      _ref10$tabIndex = _ref10.tabIndex,
      c = _ref10$tabIndex === void 0 ? 0 : _ref10$tabIndex,
      b = _ref10.onKeyDown,
      h = _objectWithoutProperties(_ref10, _excluded);
    var r = typeof e == "string",
      l = !!e;
    return /* @__PURE__ */n(k, _objectSpread(_objectSpread({
      $borderRadius: f,
      tabIndex: c,
      onKeyDown: b,
      ref: g
    }, h), {}, {
      children: [l && /* @__PURE__ */n(x, {
        "data-id": "header-box",
        $plain: r,
        children: [r && /* @__PURE__ */a(y, {
          children: e
        }), !r && e]
      }), /* @__PURE__ */a(v, {
        "data-id": "content-box",
        $minimizeHeaderPadding: l,
        children: o
      })]
    }));
  });
z.displayName = "ShadowBox";
export { m as Box, z as ShadowBox };